import React, { useEffect, useState, useContext, Fragment } from "react";
import SharedDataContext from "../../../_helper/SharedData";
import {
    getUserRole,
    showAlert,
} from "../../../Services/Shared.service";
import { Breadcrumbs, Btn, CommonModal, H6 } from "../../../AbstractElements";
import { Row, Col, Card, CardBody, Container, Modal, ModalBody, Nav, NavItem, NavLink } from "reactstrap";
import SearchTable from "../../Common/Component/SearchTable";
import { getOtpList, getOtpListBySearch } from "../../../Services/Otp.service";
import OtpTable from "./OtpTable";
import { RefreshCw } from "react-feather";
const OtpListing = () => {
    const { cityData, globalCityField, setShowApiLoader } =
        useContext(SharedDataContext);
    const [tableData, setTableData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [pagination, setPagination] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);
    const [searchData, setSearchData] = useState("");
    const [filterType, setFilterType] = useState("");
    const [filterData, setFilterData] = useState([]);

    const onChangePage = (page) => {
        console.log("page", page);
        setPagination(page - 1);
    };

    const onChangeRowsPerPage = (currentRowsPerPage) => {
        setRowsPerPage(currentRowsPerPage);
    };

    useEffect(() => {
        fetchTableData();
    }, [globalCityField.value, pagination, rowsPerPage]);

    const fetchTableData = () => {
        if (!searchData) {
            let obj = {
                page: pagination,
                size: rowsPerPage,
            };
            setLoader(true);
            getOtpList(obj)
                .then((result) => {
                    setPaginationTotalRows(result.data.count);
                    setTableData(result.data.list);
                    disableLoaders();
                })
                .catch((err) => {
                    disableLoaders();
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                });
        } else if (searchData && filterType == "search") {
            let obj = {
                searchTerm: searchData,
                page: pagination,
                size: rowsPerPage,
            };
            setLoader(true);
            getOtpListBySearch(obj)
                .then((result) => {
                    setPaginationTotalRows(result.data.count);
                    setTableData(result.data.list);
                    disableLoaders();
                })
                .catch((err) => {
                    disableLoaders();
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                });
        }
    };
    const disableLoaders = () => {
        setLoader(false);
        // setShowApiLoader(false);
    };


    useEffect(() => {
        if (!searchData && filterType != "search") {
            return;
        }
        setPagination(0)
        fetchTableData();
    }, [searchData]);

    return (
        <Fragment>
            <Breadcrumbs
                parent="User"
                subParent="OTP"
                mainTitle="OTP"
                //   span1={
                //     <FilterTable
                //       options={columns}
                //       setFilterData={setFilterData}
                //       filterData={filterData}
                //       setSearchData={setSearchData}
                //       setFilterType={setFilterType}
                //       statusData={bookingStatusData}
                //       bookingViaTypeData={bookingViaTypeData}
                //     />
                //   }
                span2={
                    <RefreshCw onClick={fetchTableData} style={{ cursor: "pointer" }} />
                }
                span3={
                    <SearchTable
                        searchData={searchData}
                        setSearchData={setSearchData}
                        setFilterData={setFilterData}
                        setFilterType={setFilterType}
                        placeholder={"Search with phone number or email"}
                        isPhoneNumber={false}
                    />
                }
            />
            <Container fluid={true} className="datatables">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-0">
                                <OtpTable
                                    fetchTableData={fetchTableData}
                                    tableData={tableData}
                                    setShowApiLoader={setLoader}
                                    onChangePage={onChangePage}
                                    paginationPerPage={rowsPerPage}
                                    paginationTotalRows={paginationTotalRows}
                                    onChangeRowsPerPage={onChangeRowsPerPage}
                                    loader={loader}
                                    cityData={cityData}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default OtpListing;
